import {
  ON_START_FORTNOX_CANCEL_ORDER, ON_FORTNOX_CANCEL_ORDER, ON_ERROR_FORTNOX_CANCEL_ORDER,
  ON_START_UPDATE_ORDER_KUNDDATA_KANUPDATE, ON_UPDATE_ORDER_KUNDDATA_KANUPDATE, ON_ERROR_UPDATE_ORDER_KUNDDATA_KANUPDATE,
  ON_START_NEW_AF_ORDER_TASK, ON_NEW_AF_ORDER_TASK, ON_ERROR_NEW_AF_ORDER_TASK,
  ON_START_GET_AF_ORDER_TASK,ON_GET_AF_ORDER_TASK,ON_ERROR_GET_AF_ORDER_TASK,
  ON_START_UPDATE_AF_ORDER_TASK, ON_UPDATE_AF_ORDER_TASK, ON_ERROR_UPDATE_AF_ORDER_TASK,
  ON_START_DELETE_AF_ORDER_TASK,ON_DELETE_AF_ORDER_TASK,ON_ERROR_DELETE_AF_ORDER_TASK,
  ON_START_GET_OFFERT_HOGIA_VARDE_TOOLTIP,ON_GET_OFFERT_HOGIA_VARDE_TOOLTIP,ON_ERROR_GET_OFFERT_HOGIA_VARDE_TOOLTIP,
  ON_GET_ORDER_KUNDDATA2_ID,ON_GET_CHANGE_ORDER_VY_SORT,
  //
  ON_START_GET_ORDER_FREE_INPUTS,ON_GET_ORDER_FREE_INPUTS,ON_ERROR_GET_ORDER_FREE_INPUTS,
    ON_NEW_ORDER,ON_GET_ORDER_PAGE_BASIC,ON_START_ORDER_CLOSE_TOASTR,ON_GET_ORDER_PAGEROWS_BASIC,
    ON_KUND_ANTAL_ORDER,ON_UPDATE_ORDER_LIST_SEARCHTYPE,ON_UPDATE_ORDER_LIST_SEARCHWORD,
    ON_START_GET_ORDER_USER_NEXT_PREV,ON_GET_ORDER_USER_NEXT_PREV,ON_ERROR_GET_ORDER_USER_NEXT_PREV,
    ON_START_NEW_ORDER,
    ON_ERROR_NEW_ORDER,
    ON_GET_ORDER_ORGNR,
    ON_ERROR_GET_ORDER_ORGNR,
    ON_START_GET_ORDER_ORGNR,
    ON_START_GET_ORDER_ID,ON_GET_ORDER_ID,ON_ERROR_GET_ORDER_ID,
    ON_START_GET_ORDER_REST_ID,ON_GET_ORDER_REST_ID,ON_ERROR_GET_ORDER_REST_ID,
    ON_START_DELETE_ORDER,
    ON_DELETE_ORDER,
    ON_ERROR_DELETE_ORDER,
    ON_START_GET_ORDER_USER,
    ON_GET_ORDER_USER,
    ON_ERROR_GET_ORDER_USER,
    ON_START_ORDER_NEW_DOC,
    ON_ORDER_NEW_DOC,
    ON_ERROR_ORDER_NEW_DOC,
    ON_START_GET_ORDER_DOC_ID,
    ON_GET_ORDER_DOC_ID,
    ON_ERROR_GET_ORDER_DOC_ID,
    ON_START_DELETE_ORDER_DOC_RAD,    ON_DELETE_ORDER_DOC_RAD,    ON_ERROR_DELETE_ORDER_DOC_RAD,
    ON_START_UPDATE_ORDER_DOC_RAD,ON_UPDATE_ORDER_DOC_RAD,ON_ERROR_UPDATE_ORDER_DOC_RAD,
    ON_START_FETCH_EXCEL_KUNDDATA_ORDER,ON_FETCH_EXCEL_KUNDDATA_ORDER,ON_ERROR_EXCEL_KUNDDATA_ORDER,
    ON_START_GET_ORDER_FORTNOX,ON_GET_ORDER_FORTNOX,ON_ERROR_GET_ORDER_FORTNOX,ON_UPDATE_ORDER_FORNOX,
    ON_SAVE_ORDER_CALC_ITEMS,
    ON_START_SAVE_ORDER_CALC_ITEMS,
    ON_ERROR_SAVE_ORDER_CALC_ITEMS,
    ON_START_GET_ORDER_HISTORY_ID,
    ON_GET_ORDER_HISTORY_ID,
    ON_ERROR_GET_ORDER_HISTORY_ID,
    ON_START_NEW_ORDER_HANDELSE,
    ON_NEW_ORDER_HANDELSE,
    ON_ERROR_NEW_ORDER_HANDELSE,
    ON_START_NEW_ORDER_KALKYL_ID,
    ON_NEW_ORDER_KALKYL_ID,
    ON_ERROR_NEW_ORDER_KALKYL_ID, 
    ON_START_NEW_ORDER_ABOKALKYL_ID,
    ON_NEW_ORDER_ABOKALKYL_ID,
    ON_ERROR_NEW_ORDER_ABOKALKYL_ID,
    ON_START_GET_ORDER_KALKYL_ID,
    ON_ERROR_GET_OFFERT_KALKYL_ID,ON_GET_OFFERT_KALKYL_ID,ON_START_GET_OFFERT_KALKYL_ID,
    ON_GET_ORDER_KALKYL_ID,
    ON_ERROR_GET_ORDER_KALKYL_ID,
    ON_START_DELETE_ORDER_KALKYL_RAD,
    ON_DELETE_ORDER_KALKYL_RAD,
    ON_ERROR_DELETE_ORDER_KALKYL_RAD,
    ON_START_UPDATE_ORDER_KALKYL_RAD,
    ON_UPDATE_ORDER_KALKYL_RAD,
    ON_ERROR_UPDATE_ORDER_KALKYL_RAD,
    ON_START_NEW_ORDER_KONTAKT_ID,
    ON_NEW_ORDER_KONTAKT_ID,
    ON_ERROR_NEW_ORDER_KONTAKT_ID,
    ON_START_ORDER_INFO_UPDATE,
    ON_NEW_ORDER_INFO_UPDATE,
    ON_ERROR_ORDER_INFO_UPDATE,
    ON_START_ORDER_UPDATE,
    ON_ORDER_UPDATE,
    ON_ERROR_ORDER_UPDATE,
    ON_START_ORDER_KUNDDATA_INSERT,
    ON_NEW_ORDER_KUNDDATA_INSERT,
    ON_ERROR_ORDER_KUNDDATA_INSERT,
    ON_START_GET_ORDER_KUNDDATA_ID,
    ON_GET_ORDER_KUNDDATA_ID,
    ON_ERROR_GET_ORDER_KUNDDATA_ID,
    ON_START_ORDER_ANTAL_UPDATE,
    ON_NEW_ORDER_ANTAL_UPDATE,
    ON_ERROR_ORDER_ANTAL_UPDATE,
    ON_START_DELETE_ORDER_KUNDDATA_RAD,ON_DELETE_ORDER_KUNDDATA_RAD,ON_ERROR_DELETE_ORDER_KUNDDATA_RAD,
    ON_START_ORDER_KUNDDATA_COPYTA,ON_ORDER_KUNDDATA_COPYTA,ON_ERROR_ORDER_KUNDDATA_COPYTA,
    ON_START_FORTNOX_NEWKUND_ORDER, ON_FORTNOX_NEWKUND_ORDER, ON_ERROR_FORTNOX_NEWKUND_ORDER,
    ON_START_ORDER_REGISTER,ON_NEW_ORDER_REGISTER,ON_ERROR_ORDER_REGISTER,
    ON_START_ORDER_REGISTER_KLAR,ON_NEW_ORDER_REGISTER_KLAR,ON_ERROR_ORDER_REGISTER_KLAR,
    ON_START_ORDER_REGISTER_SALES_MULTI, ON_ORDER_REGISTER_SALES_MULTI,ON_ERROR_ORDER_REGISTER_SALES_MULTI,
    ON_START_FETCH_ORDER_RAPPORT,ON_FETCH_ORDER_RAPPORT,ON_ERROR_FETCH_ORDER_RAPPORT,
    ON_START_ORDER_REGISTER_BEHANDLA, ON_NEW_ORDER_REGISTER_BEHANDLA, ON_ERROR_ORDER_REGISTER_BEHANDLA,
    ON_START_GET_ORDER_KEDJA,ON_GET_ORDER_KEDJA,ON_ERROR_GET_ORDER_KEDJA,
    ON_START_ORDER_DASHBOARD_UPDATE, ON_NEW_ORDER_DASHBOARD_UPDATE, ON_ERROR_ORDER_DASHBOARD_UPDATE,
    ON_START_DELETE_ORDER_HANDELSE,ON_DELETE_ORDER_HANDELSE,ON_ERROR_DELETE_ORDER_HANDELSE,
    ON_START_SNABB_ORDER,ON_SNABB_ORDER,ON_ERROR_SNABB_ORDER,
    ON_START_SNABB_VUNNEN,ON_SNABB_VUNNEN,ON_ERROR_SNABB_VUNNEN,
    ON_START_ORDER_IMPORT_KD_EXCEL, ON_ORDER_IMPORT_KD_EXCEL, ON_ERROR_ORDER_IMPORT_KD_EXCEL,
    ON_START_FORTNOX_SEND_ORDER, ON_FORTNOX_SEND_ORDER, ON_ERROR_FORTNOX_SEND_ORDER,
    ON_START_ORDER_KUNDDATA_TEMPORARY, ON_ORDER_KUNDDATA_TEMPORARY, ON_ERROR_ORDER_KUNDDATA_TEMPORARY,
    ON_START_GET_SEARCHABLE_ARTKEL_FI,ON_GET_SEARCHABLE_ARTKEL_FI,ON_ERROR_GET_SEARCHABLE_ARTKEL_FI,
    SET_ORDERVY_TYPE,
    ON_GET_ORDER_STATUS_ANTAL,
    ON_ERROR_GET_ORDER_STATUS_ANTAL,
    ON_START_GET_ORDER_STATUS_ANTAL,
    ON_UPDATE_THIS_ORDER_STATUS,
    ON_ERROR_UPDATE_THIS_ORDER_STATUS,
    ON_START_UPDATE_THIS_ORDER_STATUS,
    ON_START_GET_ORDER_VARDE_TOOLTIP,
    ON_ERROR_GET_ORDER_VARDE_TOOLTIP,
    ON_GET_ORDER_VARDE_TOOLTIP,
    ON_START_MESSAGE_KUND,  ON_MESSAGE_KUND,  ON_ERROR_MESSAGE_KUND,
    
    ON_START_CREATE_WOOCOMMERCE_ORDER,
    ON_CREATE_WOOCOMMERCE_ORDER,
    ON_ERROR_CREATE_WOOCOMMERCE_ORDER,
    ON_START_UPDATE_WOOCOMMERCE_ORDER,
    ON_UPDATE_WOOCOMMERCE_ORDER,
    ON_ERROR_UPDATE_WOOCOMMERCE_ORDER,
    FETCH_START_SET_UNAUTHE
} from "../constants/ActionTypes";
import axios from 'util/Api' 
import { history } from "store";
import { isEmpty,isUndefined } from "lodash";
//import {userSignOut} from 'actions'
import fileSaver from 'file-saver' 
import {RefreshUserInterface,getProspektByUserid1} from 'actions'
import { translate } from "../util/intlHelper";



const getClientIp = async () => {
  let Ipadress='0.0.0.0'
 /*  await fetch('https://geolocation-db.com/json/')
    .then(response => response.json())
    .then(data => {console.log(data)
      Ipadress= data.IPv4});
      */
      return Ipadress
}
//saveThisNewOrder
export const saveThisNewOrder = (Orgnr, Afid, userid,norder) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
      localStorage.removeItem("Order");
       dispatch({type: ON_START_NEW_ORDER});
       dispatch({type: ON_START_MESSAGE_KUND,payload: translate("Action.Order.Creating")});
       axios.put('kontos/Order/new', {
        
        body: {
          Order:norder,
          Orgnr:Orgnr,
          Afid:Afid,
          userid:userid
        }
      },
      {
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then(({data}) => {
        console.log("saveThisNewOrder: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_NEW_ORDER, payload: data.results});
           if(norder.OrderVariant === 'orderbekraftelse' && parseInt(data.results.orderBekraftelseID) !== 0) {
              let Kontakt = {FName: '', LName: '', Email: '', Tele: ''}
              if(!isUndefined(norder.kontakt) || !isUndefined(norder.kontaktObj)) {
                Kontakt = parseInt(norder.kontakt) === 0 ? norder.kontaktObj : norder.kontakt
              }
              history.push(
              {
                pathname: '/app/Dokument',
                state: { 
                  Docid: data.results.orderBekraftelseID,
                  UtkastFlag: 1,
                  FromCreateDocument: 1,
                  Kontakt: data.results.kontaktID,
                  FromPageFlag: 'OffertFlag'
                }
              }
            )
           } else {
            history.push({
              pathname: '/app/Orderkort',
              state: { OrderId: data.results.Order.Order[0] }
            });
            localStorage.setItem("Order",`${data.results.Order.Order[0].id}_${data.results.Order.Order[0].Orgnr}`);
            dispatch(getOrderByIDRest1(Orgnr,Afid,userid, data.results.Order.Order[0].id))
           }
         } else {
           dispatch({type: ON_ERROR_NEW_ORDER, payload: data.error});
           dispatch({type: ON_ERROR_MESSAGE_KUND,payload: data.error})
         }
         let prospektFilter =isUndefined(localStorage.ProspektFilter)?[]:JSON.parse(localStorage.ProspektFilter)
       dispatch(getProspektByUserid1(Afid,userid,0,prospektFilter))
       ////dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
         dispatch({type: ON_ERROR_NEW_ORDER, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
     }
   }
//onCopythisOrder
export const onCopythisOrder = (Afid,userid,nOrder) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
      
      //dispatch({type: ON_START_NEW_ORDER});
      dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Order.Creating")});
      axios.put('kontos/Order/Copy', {
        
        body: {
          Order:nOrder,
          Afid:Afid,
          userid:userid
        }
      },
      {
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }
      })
    .then(({data}) => {
      console.log("saveThisNewOrder: ", data);
      if (data.results) {
        localStorage.removeItem("Order");
        dispatch({type: ON_NEW_ORDER, payload: data.results});
        history.push({
          pathname: '/app/Orderkort',
          state: { OrderId: data.results.Order.Order[0] }
        });
        localStorage.setItem("Order",`${data.results.Order.Order[0].id}_${data.results.Order.Order[0].Orgnr}`);
        dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
      } 
      else {
        dispatch({type: ON_ERROR_NEW_ORDER, payload: data.error});
        dispatch({type: ON_ERROR_MESSAGE_KUND,payload: data.error})
      }
    })
    .catch(function (error) {
      dispatch({type: ON_ERROR_NEW_ORDER, payload: error.message});
      if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
        } 
      } 
      if(error.message === "Network Error"){
        //reload and remove token 
        // //dispatch(userSignOut())
      } 
    })
  }
}
//CreateSnabbOrder
export const CreateSnabbOrder=(Afid,userid,Orgnr,Avtalid,stateObj)=>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_SNABB_ORDER});
    axios.put('kontos/Order/Snabb', {
     
     body: {
        Avtalid:Avtalid,
        Orgnr:Orgnr,
        Afid:Afid,
        stateObj:stateObj,
        userid:userid
     }},
     {
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(({data}) => {
     console.log("CreateSnabbOrder: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_SNABB_ORDER, payload: data.results});
        history.push({
         pathname: '/app/Orderkort',
         state: { OrderId: data.results.Order.Order[0] }
       });
       localStorage.setItem("Order",`${data.results.Order.Order[0].id}_${data.results.Order.Order[0].Orgnr}`);
       dispatch(getOrderByIDRest1(Orgnr,Afid,userid, data.results.Order.Order[0].id))
      } else {
        dispatch({type: ON_ERROR_SNABB_ORDER, payload: data.error});
      }
 //   ////dispatch(RefreshUserInterface(userid))
  }).catch(function (error) {
      dispatch({type: ON_ERROR_SNABB_ORDER, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
  }
}  

export const getCurrentOrderVardeTooltip = (userid,Afid,OrderId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_ORDER_VARDE_TOOLTIP});
    axios.get('kontos/Order/tooltip',
    { params:{Afid:Afid,userid:userid,OrderId}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getCurrentOrderVardeTooltip: ", data);
       if (data.results) {
         dispatch({type: ON_GET_ORDER_VARDE_TOOLTIP, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_ORDER_VARDE_TOOLTIP, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ORDER_VARDE_TOOLTIP, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

export const getCurrentHogiaOffertVardeTooltip = (userid,Afid,OrderId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_OFFERT_HOGIA_VARDE_TOOLTIP});
    axios.get('kontos/Offert/Hogia/tooltip',
    { params:{Afid:Afid,userid:userid,OrderId}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getCurrentHogiaOffertVardeTooltip: ", data);
       if (data.results) {
         dispatch({type: ON_GET_OFFERT_HOGIA_VARDE_TOOLTIP, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_OFFERT_HOGIA_VARDE_TOOLTIP, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_OFFERT_HOGIA_VARDE_TOOLTIP, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

//getOrderByOrgnr
export const getOrderByOrgnr = (userid,Afid,Orgnr,type,Page,searchWord) =>{
  const jwt =  JSON.parse(localStorage.token);
  let page = isUndefined(Page)?0:Page
  let Type = isUndefined(type)?3:type
  let SearchWord = isUndefined(searchWord)?"":searchWord
  return (dispatch) => {
    dispatch({type: ON_START_GET_ORDER_ORGNR});
    dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Orders.geting")});
    axios.get('kontos/Order/getByOrgnr',
    { params:{
      Orgnr:Orgnr,
      Afid:Afid,
      userid:userid,
      page:page,
      SearchWord:SearchWord,
      Type:Type,
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getOrderByOrgnr: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_ORDER_ORGNR, payload: data.results});
         dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Orders.get")});
       } else {
         dispatch({type: ON_ERROR_GET_ORDER_ORGNR, payload: data.error});
         dispatch({type: ON_ERROR_MESSAGE_KUND,payload:translate("Error.Orders.get")})
       }
     dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ORDER_ORGNR, payload: error.message});
       dispatch({type: ON_ERROR_MESSAGE_KUND,payload:translate("Error.Orders.get")})
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

export const createNewOrderWoocommerce = ( userid, Afid,OrderId, Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_CREATE_WOOCOMMERCE_ORDER});
     axios.post('kontos/Woocommerce/Order/new', {
      method: 'POST',
      body: {
        userid:userid,
        Afid:Afid,
        OrderId, Orgnr
      }},{

      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("createNewOrderWoocommerce: ", data);
       if (data.success) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_CREATE_WOOCOMMERCE_ORDER, payload: data});
       } else {
         dispatch({type: ON_ERROR_CREATE_WOOCOMMERCE_ORDER, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_CREATE_WOOCOMMERCE_ORDER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
export const updateOrderWoocommerce = ( userid, Afid,OrderId, Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_WOOCOMMERCE_ORDER});
     axios.put('kontos/Woocommerce/Order/update', {
      
      body: {
        userid:userid,
        Afid:Afid,
        OrderId, Orgnr
      }
    },
    {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("updateOrderWoocommerce: ", data);
       if (data.success) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_UPDATE_WOOCOMMERCE_ORDER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_UPDATE_WOOCOMMERCE_ORDER, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_WOOCOMMERCE_ORDER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
export const getOrderByIDRest1=(Orgrn,Afid,userid,Order)=>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
   dispatch({type: ON_START_GET_ORDER_REST_ID});
   axios.get('kontos/Order/getByIdRest',
   { params:{Orgnr:Orgrn,Afid:Afid,userid:userid,Order:Order}, 
    headers: { 'Authorization': `Bearer ${jwt}`} }      
    ).then(({data}) => {
     console.log("getOrderByID: ", data);
      if (data.results) {
       dispatch({type: ON_GET_ORDER_REST_ID, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_GET_ORDER_REST_ID, payload: data.error});
     }
   }).catch(function (error) {
      dispatch({type: ON_ERROR_GET_ORDER_REST_ID, payload: error.message});
         if(!isUndefined(error.response)){
       if (error.response.status === 401) {
         dispatch({type: FETCH_START_SET_UNAUTHE});
        } 
      } 
      if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      } 
    }); /**/
 }
}

//getOrderByID
export const getOrderByID = (Orgrn,Afid,userid,Order) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    dispatch({type: ON_START_GET_ORDER_ID});
    axios.get('kontos/Order/getById',
    { params:{Orgnr:Orgrn,Afid:Afid,userid:userid,Order:Order}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getOrderByID: ", data);
       if (data.results) {
        history.push({
          pathname: '/app/Orderkort',
          state: { OrderId: data.results.Order.Order[0] }
        })
        localStorage.setItem("Order",`${data.results.Order.Order[0].id}_${data.results.Order.Order[0].Orgnr}`);
        dispatch({type: ON_GET_ORDER_ID, payload: data.results});
        dispatch(getOrderByIDRest1(Orgrn,Afid,userid,Order))
       } else {
         dispatch({type: ON_ERROR_GET_ORDER_ID, payload: data.error});
      }
    dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ORDER_ID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
//getKOrderByID
export const getKOrderByID = (Orgrn,Order,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    dispatch({type: ON_START_GET_ORDER_ID});
    axios.get('kontos/Order/getKById',
    { params:{Orgnr:Orgrn,Order:Order,userid:userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getKOrderByID: ", data);
       if (data.results) {
        history.push({
          pathname: '/app/Orderkort',
          state: { OrderId: data.results.Order.Order[0] }
        })
        localStorage.setItem("Order",`${data.results.Order.Order[0].id}_${data.results.Order.Order[0].Orgnr}`);
        dispatch({type: ON_GET_ORDER_ID, payload: data.results});
        dispatch(getOrderByIDRest1(Orgrn,data.results.Order.Order[0].Afid,userid,Order))
       } else {
         dispatch({type: ON_ERROR_GET_ORDER_ID, payload: data.error});
      }
    dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ORDER_ID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
//deleteOrderByID 
export const deleteOrderByID = ( Afid, userid, Order,type,Page,searchWord) =>{
  const jwt = JSON.parse(localStorage.token);;
  let page = isUndefined(Page)?0:Page
  let Type = isUndefined(type)?"":type
  let SearchWord = isUndefined(searchWord)?"":searchWord
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_ORDER});
     dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Order.deleting")});
     axios.delete('kontos/Order/delete', {
       method: 'DELETE',
       data: {
         Afid:Afid,
         userid:userid,
         isList:0,
         Order:Order,
         Page:page,
         type:Type,
         searchWord:SearchWord,
       },
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("deleteOrderByID: ", data.message);
     if (data.success) {
       console.log(data);
       dispatch({type: ON_DELETE_ORDER, payload: data});
       dispatch({type: ON_KUND_ANTAL_ORDER, payload: data});
       dispatch({type: ON_MESSAGE_KUND,payload:data.results.message});
     } else {
       dispatch({type: ON_ERROR_DELETE_ORDER, payload: data.error});
       dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Order.delete")});
     }
     ////dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
     dispatch({type: ON_ERROR_DELETE_ORDER, payload: error.message});
     dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Order.delete")});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
   });
   }
}
export const deleteOrderProjectByID = ( Afid, userid, Order) =>{
  const jwt = JSON.parse(localStorage.token);;
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_ORDER});
     axios.delete('kontos/Order/delete', {
       method: 'DELETE',
       data: {
         Afid:Afid,
         userid:userid,
         isList:2,
         Order:Order
       },
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("deleteOrderByID: ", data.message);
     if (data.success) {
       console.log(data);
       dispatch({type: ON_DELETE_ORDER, payload: data});
       dispatch({type: ON_KUND_ANTAL_ORDER, payload: data});
     } else {
       dispatch({type: ON_ERROR_DELETE_ORDER, payload: data.error});
     }
     ////dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
     dispatch({type: ON_ERROR_DELETE_ORDER, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
   });
   }
}
export const deleteOrderArendeByID = ( Afid, userid, Order) =>{
  const jwt = JSON.parse(localStorage.token);;
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_ORDER});
     axios.delete('kontos/Order/delete', {
       method: 'DELETE',
       data: {
         Afid:Afid,
         userid:userid,
         isList:3,
         Order:Order
       },
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("deleteOrderByID: ", data.message);
     if (data.success) {
       console.log(data);
       dispatch({type: ON_DELETE_ORDER, payload: data});
       dispatch({type: ON_KUND_ANTAL_ORDER, payload: data});
     } else {
       dispatch({type: ON_ERROR_DELETE_ORDER, payload: data.error});
     }
     ////dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
     dispatch({type: ON_ERROR_DELETE_ORDER, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
   });
   }
}
//deleteOrderListByID 
export const deleteOrderListByID = ( Afid, userid, Order,type,Filterstate,Page,searchWord,searchtype,pageRows = 15) =>{
  let Filterstate1 = isUndefined(Filterstate)?[]:Filterstate
  let Page1 = isUndefined(Page)?1:Page
  let searchWord1 = isUndefined(searchWord)?"":searchWord
  let searchtype1 = isUndefined(searchtype)?0:searchtype
  const jwt = JSON.parse(localStorage.token);;
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_ORDER});
     axios.delete('kontos/Order/delete', {
       method: 'DELETE',
       data: {
         Afid:Afid,
         userid:userid,
         isList:1,
         listtype:type,
         Order:Order,
         Filterstate:Filterstate1,
         Page:Page1,
         searchWord:searchWord1,
         searchtype:searchtype1,
         pageRows:pageRows
       },
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("deleteOrderListByID: ", data.message);
     if (data.success) {
       console.log(data);
       dispatch({type: ON_DELETE_ORDER, payload: data});
     } else {
       dispatch({type: ON_ERROR_DELETE_ORDER, payload: data.error});
     }
     ////dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
     dispatch({type: ON_ERROR_DELETE_ORDER, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
   });
   }
}
//getOrderByUserID
export const getOrderByUserID = (Afid,Filterstate,userid,type,Page=1,searchWord,searchtype, pageRows = 25,OrderSortObj={column: 'Regdate', Type: 1}) =>{
  /*
  0. Utkast
  1. inkommande
  2. Klara
  */
  Page = (isUndefined(Page)?1:Page)
  pageRows = (isUndefined(pageRows)?25:pageRows)
  searchtype = (isUndefined(searchtype)?0:searchtype)
  searchWord = (isUndefined(searchWord)?"":searchWord)
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_ORDER_USER});
    dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Orders.geting")});
    axios.get('kontos/Order/getByUser',
    { params:{Afid:Afid,userid:userid,type:type,Page:Page,searchWord:searchWord,Filterstate:Filterstate,searchtype:searchtype, pageRows:pageRows,
      OrderSortObj:OrderSortObj
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getOrderByUserID: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_ORDER_USER, payload: data.results});
         dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Orders.get")});
         
       } else {
         dispatch({type: ON_ERROR_GET_ORDER_USER, payload: data.error});
         dispatch({type: ON_ERROR_MESSAGE_KUND,payload:translate("Error.Orders.get")});
       }
     dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ORDER_USER, payload: error.message});
       dispatch({type: ON_ERROR_MESSAGE_KUND,payload:translate("Error.Orders.get")});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getOrderByKedja
export const getOrderByKedja = (Afid,type,Page,searchWord) =>{
  /*
  0. Utkast
  1. inkommande
  2. Klara
  */
  Page = (isUndefined(Page)?0:Page)
  searchWord = (isUndefined(searchWord)?"":searchWord)
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_GET_ORDER_KEDJA});
    axios.get('kontos/Order/getByKedja',
    { params:{Afid:Afid,type:type,Page:Page,searchWord:searchWord}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getOrderByKedja: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_ORDER_KEDJA, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_ORDER_KEDJA, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ORDER_KEDJA, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

//saveNewDocOrder
export const saveNewDocOrder = (Orgrn, Afid, userid,Order,Avtal,Doc) =>{
  const jwt =  JSON.parse(localStorage.token);
  let files = Doc.file; 

  var fromdata = new FormData();
  fromdata.append("Orgnr",Orgrn)
  fromdata.append("Afid",Afid)
  fromdata.append("userid",userid)
  fromdata.append("Order",Order)
  fromdata.append("Avtal",Avtal)
  fromdata.append("DocType",Doc.type)
  fromdata.append("DocName",Doc.Name)
  files.forEach(file => fromdata.append('files[]', file));
  return (dispatch) => {
    dispatch({type: ON_START_ORDER_NEW_DOC});
    axios.post('kontos/Order/Doc/new',
    fromdata,
     {
       body:{
        Orgnr:Orgrn,
        Afid:Afid,
        userid:userid,
        Order:Order,
        Avtal:Avtal,
        DocType:Doc.type,
        DocName:Doc.Name
       },
       headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
     }
     ).then(({data}) => {
    console.log("saveNewDocOrder: ", data);
     if (data) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_ORDER_NEW_DOC, payload: data});
       dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
     } else {
       dispatch({type: ON_ERROR_ORDER_NEW_DOC, payload: data.message});
     }
   ////dispatch(RefreshUserInterface(userid))
  }).catch(function (error) {
     dispatch({type: ON_ERROR_ORDER_NEW_DOC, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
   });
  } 
 }
 //getOrderDocsById
 export const getOrderDocsById = (Orgrn,Afid,userid,Order,ownProps) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    dispatch({type: ON_START_GET_ORDER_DOC_ID});
    axios.get('kontos/Order/getDOCById',
    { params:{Orgnr:Orgrn,Afid:Afid,userid:userid,Order:Order}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getOrderDocsById: ", data);
       if (data.results) {
        dispatch({type: ON_GET_ORDER_DOC_ID, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_ORDER_DOC_ID, payload: data.error});
      }
     dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ORDER_DOC_ID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}

//
export const updateThisDocOrder = (Afid,userid,Updatedrad) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_UPDATE_ORDER_DOC_RAD});
    axios.put('kontos/Order/Doc/update', {
     
     body: {
       Afid:Afid,
       userid:userid,
       Updatedrad:Updatedrad,
       ipAdress:ipAdress,
     }
    },
    {
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(({data}) => {
     console.log("updateThisDocOrder: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_UPDATE_ORDER_DOC_RAD, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_UPDATE_ORDER_DOC_RAD, payload: data.error});
      }
    }).catch(function (error) {
      dispatch({type: ON_ERROR_UPDATE_ORDER_DOC_RAD, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     } 
    });
  }
}
//deleteThisOrderDoc
export const deleteThisOrderDoc = (Afid,userid,drad) =>{
  const jwt = JSON.parse(localStorage.token);;
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_ORDER_DOC_RAD});
     axios.delete('kontos/Order/Doc/delete', {
       method: 'DELETE',
       data: {
         rad:drad,
         Afid:Afid,
         userid:userid
       },
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("deleteThisOrderDoc: ", data.message);
     if (data.success) {
       console.log(data);
       dispatch({type: ON_DELETE_ORDER_DOC_RAD, payload: data.results});
     } else {
       dispatch({type: ON_ERROR_DELETE_ORDER_DOC_RAD, payload: data.error});
     }
     ////dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
     dispatch({type: ON_ERROR_DELETE_ORDER_DOC_RAD, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
   });
   }
}
//getOrderHistorikById
export const getOrderHistorikById = (Orgrn,Afid,userid,Order,ownProps) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    dispatch({type: ON_START_GET_ORDER_HISTORY_ID});
    axios.get('kontos/Order/gethistoryById',
    { params:{Orgnr:Orgrn,Afid:Afid,userid:userid,Order:Order}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getOrderHistorikById: ", data);
       if (data.results) {
        dispatch({type: ON_GET_ORDER_HISTORY_ID, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_ORDER_HISTORY_ID, payload: data.error});
      }
     dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ORDER_HISTORY_ID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
//SaveAvtalNewHandelseOrder
export const SaveAvtalNewHandelseOrder = (Afid,userid,Orgnr,Order,Avtal,handelse) =>{
  const jwt =  JSON.parse(localStorage.token);
  let files = handelse.file;
  console.log(files)
  var fromdata = new FormData();
  fromdata.append("Order",Order)
  fromdata.append("Avtal",Avtal)
  fromdata.append("Orgnr",Orgnr)
  fromdata.append("Afid",Afid)
  fromdata.append("userid",userid)
  fromdata.append("handelse",handelse.text)
  fromdata.append("Type","Order Anteckning")
  if(files !==""){
    files.forEach(file => fromdata.append('files[]', file));
  }
  console.log(!isEmpty(files))
  return (dispatch) => {
    dispatch({type: ON_START_NEW_ORDER_HANDELSE});
    axios.post('kontos/Order/handelse/new',
    fromdata,
     {
       body:{
        Orgnr:Orgnr,
        Avtal:Avtal,
        Order:Order,
        Afid:Afid,
        userid:userid,
        text:handelse.text,
        Type:"Order Anteckning"
       },
       headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
     }
     ).then(({data}) => {
    console.log("SaveAvtalNewHandelseOrder: ", data);
     if (data.results) {
       dispatch({type: ON_NEW_ORDER_HANDELSE, payload: data.results});
     } else {
       dispatch({type: ON_ERROR_NEW_ORDER_HANDELSE, payload: data.error});
     }
   ////dispatch(RefreshUserInterface(userid))
  }).catch(function (error) {
     dispatch({type: ON_ERROR_NEW_ORDER_HANDELSE, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
   });
  } 
}

export const onSaveOrderCalcItems = (OrderId, Orgnr, OrderAfid, CalcItems, CalcItemsUpdatesArr) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_SAVE_ORDER_CALC_ITEMS});
      axios.post('kontos/Order/onSaveOrderCalcItems', {
        OrderId, Orgnr, CalcItems, CalcItemsUpdatesArr, OrderAfid
      }, 
      {
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
      }).then(({data}) => {
       console.log("onSaveOrderCalcItems: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_SAVE_ORDER_CALC_ITEMS, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_SAVE_ORDER_CALC_ITEMS, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_SAVE_ORDER_CALC_ITEMS, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }

//saveNewNormalKalkylOrder
export const saveNewNormalKalkylOrder = (Afid,userid,Orderid,Orgnr,nKalkyl) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_NEW_ORDER_KALKYL_ID});
      axios.put('kontos/Order/KalkylNormal/new', {
       
       body: {
         Afid:Afid,
         userid:userid,
         Aid:Orderid,
         Orgnr:Orgnr,
         Kalkyl:nKalkyl
       }
      },
      {
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("saveNewNormalKalkylOrder: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_NEW_ORDER_KALKYL_ID, payload: data.results});
          dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
        } else {
          dispatch({type: ON_ERROR_NEW_ORDER_KALKYL_ID, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_NEW_ORDER_KALKYL_ID, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
 //saveNewAbonnemangKalkylOrder
 export const saveNewAbonnemangKalkylOrder = (Afid,userid,Aid,Orgnr,nKalkyl) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_NEW_ORDER_ABOKALKYL_ID});
      axios.put('kontos/Order/KalkylAbonnemange/new', {
       
       body: {
         Afid:Afid,
         userid:userid,
         Aid:Aid,
         Orgnr:Orgnr,
         Kalkyl:nKalkyl
       }
      },
      {
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("saveNewAbonnemangKalkylOrder: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_NEW_ORDER_ABOKALKYL_ID, payload: data.results});
          dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
        } else {
          dispatch({type: ON_ERROR_NEW_ORDER_ABOKALKYL_ID, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_NEW_ORDER_ABOKALKYL_ID, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//getOrderKalkylById
export const getOrderKalkylById = (Orgrn,Afid,userid,Order,ownProps) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    dispatch({type: ON_START_GET_ORDER_KALKYL_ID});
    axios.get('kontos/Order/getKalkylById',
    { params:{Orgnr:Orgrn,Afid:Afid,userid:userid,Order:Order}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getOrderKalkylById: ", data);
       if (data.results) {
        dispatch({type: ON_GET_ORDER_KALKYL_ID, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_ORDER_KALKYL_ID, payload: data.error});
      }
     dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ORDER_KALKYL_ID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
//getOffertKalkylById
export const getOffertKalkylById = (Orgrn,Afid,userid,Offert,ownProps) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    dispatch({type: ON_START_GET_OFFERT_KALKYL_ID});
    axios.get('kontos/Offert/getKalkylById',
    { params:{Orgnr:Orgrn,Afid:Afid,userid:userid,Offert:Offert}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getOffertKalkylById: ", data);
       if (data.results) {
        dispatch({type: ON_GET_OFFERT_KALKYL_ID, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_OFFERT_KALKYL_ID, payload: data.error});
      }
     dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_OFFERT_KALKYL_ID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}

//deleteThisRowKalkylOrder
export const deleteThisRowKalkylOrder = (Afid,userid,nrad) =>{
  const jwt = JSON.parse(localStorage.token);;
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_ORDER_KALKYL_RAD});
     axios.delete('kontos/Order/Kalkyl/delete', {
       method: 'DELETE',
       data: {
         rad:nrad,
         Afid:Afid,
         userid:userid
       },
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("deleteThisRowKalkylOrder: ", data.message);
     if (data.success) {
       console.log(data);
       dispatch({type: ON_DELETE_ORDER_KALKYL_RAD, payload: data});
       dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
     } else {
       dispatch({type: ON_ERROR_DELETE_ORDER_KALKYL_RAD, payload: data.error});
     }
     ////dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
     dispatch({type: ON_ERROR_DELETE_ORDER_KALKYL_RAD, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
   });
   }
}
//UpdateNormalKalkylOrder
export const UpdateNormalKalkylOrder = (Afid,userid,Aid,Orgnr,Kalkyl,newKalkyl) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_UPDATE_ORDER_KALKYL_RAD});
      axios.put('kontos/Order/Kalkyl/All/update', {
       
       body: {
         Afid:Afid,
         userid:userid,
         Aid:Aid,
         Orgnr:Orgnr,
         newKalkyl:newKalkyl,
         Kalkyl:Kalkyl
       }
      },
      {
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("updateThisRowKalkylOrder: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_UPDATE_ORDER_KALKYL_RAD, payload: data.results});
          dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
        } else {
          dispatch({type: ON_ERROR_UPDATE_ORDER_KALKYL_RAD, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_ORDER_KALKYL_RAD, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//updateThisRowKalkylOrder
export const updateThisRowKalkylOrder = (Afid,userid,nrad) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_UPDATE_ORDER_KALKYL_RAD});
      axios.put('kontos/Order/Kalkyl/update', {
       
       body: {
         Afid:Afid,
         userid:userid,
         nrad:nrad
       }
      },
      {
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("updateThisRowKalkylOrder: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_UPDATE_ORDER_KALKYL_RAD, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_UPDATE_ORDER_KALKYL_RAD, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_ORDER_KALKYL_RAD, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
 //saveKontaktOrderId
  export const saveKontaktOrderId = (Orgnr,Afid,userid,Orderid,Kontakt,type) =>{
    const jwt =  JSON.parse(localStorage.token);
      return (dispatch) => {
        dispatch({type: ON_START_NEW_ORDER_KONTAKT_ID});
        axios.put('kontos/Order/Kontakt/new', {
         
         body: {
           Afid:Afid,
           userid:userid,
           Orderid:Orderid,
           Orgnr:Orgnr,
           type:type,
           Kontakt:Kontakt
         },
        },
        {
         headers: {
             'content-type': 'application/json',
             'Authorization':   `Bearer ${jwt}`
         }       
     }).then(({data}) => {
         console.log("saveKontaktOrderId: ", data);
          if (data.results) {
           // dispatch({type: FETCH_ALL_CONTACT});
            dispatch({type: ON_NEW_ORDER_KONTAKT_ID, payload: data.results});
            dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
          } else {
            dispatch({type: ON_ERROR_NEW_ORDER_KONTAKT_ID, payload: data.error});
          }
        ////dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
          dispatch({type: ON_ERROR_NEW_ORDER_KONTAKT_ID, payload: error.message});
             if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
        });
      }
   }
//saveOrderInfo
export const saveOrderInfo =  (Orgnr,Afid,userid,Orderid,infostate) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_ORDER_INFO_UPDATE});
      axios.put('kontos/Order/info/update', {
       
       body: {
         Afid:Afid,
         userid:userid,
         Orderid:Orderid,
         Orgnr:Orgnr,
         infostate:infostate
       }
      },
      {
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("saveOrderInfo: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_NEW_ORDER_INFO_UPDATE, payload: data.results});
          dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
        } else {
          dispatch({type: ON_ERROR_ORDER_INFO_UPDATE, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_ORDER_INFO_UPDATE, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
 //saveThisOrder
 export const saveThisOrder =  (Orgnr,Afid,userid,Aid,AvtalId,Order)  =>{
  const jwt =  JSON.parse(localStorage.token);
  let files = isEmpty(Order.Betalning.AbonnemangslistaFileOrder)?[]:Order.Betalning.AbonnemangslistaFileOrder.file; 
  console.log(files)
  var fromdata = new FormData();
  fromdata.append("Orgnr",Orgnr)
  fromdata.append("Afid",Afid)
  fromdata.append("userid",userid)
  fromdata.append("Orderid",Aid)
  fromdata.append("AvtalId",AvtalId)
  fromdata.append("Order",JSON.stringify(Order))
  fromdata.append('files[]', files);
  
    return (dispatch) => {
      dispatch({type: ON_START_ORDER_UPDATE});
      axios.post('kontos/Order/update', 
       fromdata,{
       body: {
         Afid:Afid,
         userid:userid,
         Orderid:Aid,
         AvtalId:AvtalId,
         Orgnr:Orgnr
       },
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("saveThisOrder: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_ORDER_UPDATE, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_ORDER_UPDATE, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_ORDER_INFO_UPDATE, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
 //saveThoseKundData
 export const saveThoseKundData =  (Afid,userid,Orderid,AvtalId,Kunddata,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_ORDER_KUNDDATA_INSERT});
      axios.put('kontos/Order/Kunddata/insert', {
       
       body: {
         Afid:Afid,
         userid:userid,
         Orderid:Orderid,
         AvtalId:AvtalId,
         Orgnr:Orgnr,
         Kunddata:Kunddata
       }
      },
      {
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("saveThoseKundData: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_NEW_ORDER_KUNDDATA_INSERT, payload: data.results});
          dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
        } else {
          dispatch({type: ON_ERROR_ORDER_KUNDDATA_INSERT, payload: data.error});
        }
      //////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_ORDER_KUNDDATA_INSERT, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//SaveKunddataTemp
export const SaveKunddataTemp =  (Afid,userid,Orderid,AvtalId,Kunddata,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_ORDER_KUNDDATA_TEMPORARY});
      axios.put('kontos/Order/Kunddata/saveTemporary', {
       
       body: {
         Afid:Afid,
         userid:userid,
         Orderid:Orderid,
         AvtalId:AvtalId,
         Orgnr:Orgnr,
         Kunddata:Kunddata
       }
      },
      {
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("SaveKunddataTemp: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_ORDER_KUNDDATA_TEMPORARY, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_ORDER_KUNDDATA_TEMPORARY, payload: data.error});
        }
      //////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_ORDER_KUNDDATA_TEMPORARY, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
 
//getOrderKundData
export const getOrderKundData = (Afid,userid,Aid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    dispatch({type: ON_START_GET_ORDER_KUNDDATA_ID});
    axios.get('kontos/Order/Kunddata/getByOid',
    { params:{Afid:Afid,userid:userid,OrderId:Aid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getOrderKundData: ", data);
       if (data.results) {
        dispatch({type: ON_GET_ORDER_KUNDDATA_ID, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_ORDER_KUNDDATA_ID, payload: data.error});
      }
    dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ORDER_KUNDDATA_ID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
//saveOrderAntalNew
export const saveOrderAntalNew =  (Orgnr,Afid,userid,Orderid,infostate,KundData,type,isProject = 0) =>{
  /*
  0 update
  1 delete
  */
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_ORDER_ANTAL_UPDATE});
      axios.put('kontos/Order/antalNew/update', {
       
       body: {
         Afid:Afid,
         userid:userid,
         Orderid:Orderid,
         Orgnr:Orgnr,
         KundData:JSON.stringify(KundData),
         infostate:infostate,
         isProject:isProject
       }
      },
      {
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("saveOrderAntal: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
         if(parseInt(type) === 1){
           dispatch({type: ON_DELETE_ORDER_KUNDDATA_RAD, payload: data.results});
         }
         else{
          if(isProject === 0){
          dispatch({type: ON_NEW_ORDER_ANTAL_UPDATE, payload: data.results});
          dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
          }else{
            //ON_GET_ORDER_KUNDDATA_ID
            dispatch({type: ON_GET_ORDER_KUNDDATA2_ID, payload: data.results});
          }
         }          
        } else {
          dispatch({type: ON_ERROR_ORDER_ANTAL_UPDATE, payload: data.error});
        }
    //  ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_ORDER_ANTAL_UPDATE, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//saveOrderAntal
export const saveOrderAntal =  (Orgnr,Afid,userid,Orderid,infostate) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_ORDER_ANTAL_UPDATE});
      axios.put('kontos/Order/antal/update', {
       
       body: {
         Afid:Afid,
         userid:userid,
         Orderid:Orderid,
         Orgnr:Orgnr,
         infostate:infostate
       }
      },
      {
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("saveOrderAntal: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_NEW_ORDER_ANTAL_UPDATE, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_ORDER_ANTAL_UPDATE, payload: data.error});
        }
    //  ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_ORDER_ANTAL_UPDATE, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//deleteThisRowKundDataOrder
export const deleteThisRowKundDataOrder = (Afid,userid,Aid,nrad,Orgnr) =>{
  const jwt = JSON.parse(localStorage.token);;
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_ORDER_KUNDDATA_RAD});
     axios.delete('kontos/Order/Kunddata/delete', {
       method: 'DELETE',
       data: {
         rad:nrad,
         OrderId:Aid,
         Orgnr:Orgnr,
         Afid:Afid,
         userid:userid
       },
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("deleteThisRowKundDataOrder: ", data);
     if (data.success) {
       dispatch({type: ON_DELETE_ORDER_KUNDDATA_RAD, payload: data.results});
       dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
     } else {
       dispatch({type: ON_ERROR_DELETE_ORDER_KUNDDATA_RAD, payload: data.error});
     }
     ////dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
     dispatch({type: ON_ERROR_DELETE_ORDER_KUNDDATA_RAD, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
   });
   }
}
//CopytoKDRows
export const CopytoKDRows =  (Afid,userid,Orderid,AvtalId,Meta,Value,Kunddata,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_ORDER_KUNDDATA_COPYTA});
      axios.put('kontos/Order/Kunddata/CopyToAll', {
       
       body: {
         Afid:Afid,
         userid:userid,
         Orderid:Orderid,
         AvtalId:AvtalId,
         Orgnr:Orgnr,
         Meta:Meta,
         Value:Value,
         Kunddata:Kunddata
       }
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("CopytoKDRows: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_ORDER_KUNDDATA_COPYTA, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_ORDER_KUNDDATA_COPYTA, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_ORDER_KUNDDATA_COPYTA, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }

 export const RegisterThisOrder =  (Orgrn, Afid, userid, Order,Avtalid,RegDate,KundStatus) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_ORDER_REGISTER});
      axios.put('kontos/Order/Register', {
       
       body: {
        Afid:Afid,
         userid:userid,
         Avtalid:Avtalid,
         Order:Order,
         RegDate:RegDate,
         KundStatus:KundStatus,
         Orgrn:Orgrn
       },
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("RegisterThisOrder: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_NEW_ORDER_REGISTER, payload: data.results});
          dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
        } else {
          dispatch({type: ON_ERROR_ORDER_REGISTER, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_ORDER_REGISTER, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
 export const RegisterThisOrderklar =  (Orgrn, Afid, userid, Order,Avtalid,dateState,OrderStatus) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_ORDER_REGISTER_KLAR});
      axios.put('kontos/Order/Register/Klar', {
       
       body: {
        Afid:Afid,
         userid:userid,
         Avtalid:Avtalid,
         Order:Order,
         Orgrn:Orgrn,
         dateState:dateState,
         OrderStatus:OrderStatus,
       },
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("RegisterThisOrderklar: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_NEW_ORDER_REGISTER_KLAR, payload: data.results});
          dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
          let prospektFilter =isUndefined(localStorage.ProspektFilter)?[]:JSON.parse(localStorage.ProspektFilter)
          dispatch(getProspektByUserid1(Afid,userid,0,prospektFilter))
        } else {
          dispatch({type: ON_ERROR_ORDER_REGISTER_KLAR, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_ORDER_REGISTER_KLAR, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }


 export const RegisterThisOrderSalesMulti =  (Orders, UpdateCustomerStatus,UpdateAvtalKalk,callback) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_ORDER_REGISTER_SALES_MULTI});
      axios.put('kontos/Order/Register/SalesMutli', {
          UpdateCustomerStatus,UpdateAvtalKalk, Orders
      }, 
      {
       
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
      }).then(({data}) => {
       console.log("RegisterThisOrderklar: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_ORDER_REGISTER_SALES_MULTI, payload: data.results});
          if(callback) callback()
        } else {
          dispatch({type: ON_ERROR_ORDER_REGISTER_SALES_MULTI, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_ORDER_REGISTER_SALES_MULTI, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
 //RegisterThisOrderbehandla
 export const RegisterThisOrderbehandla =  (Orgrn, Afid, userid, Order,Avtalid) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_ORDER_REGISTER_BEHANDLA});
      axios.put('kontos/Order/Register/Behandla', {
       
       body: {
        Afid:Afid,
         userid:userid,
         Avtalid:Avtalid,
         Order:Order,
         Orgrn:Orgrn,
       },
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("RegisterThisOrderbehandla: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_NEW_ORDER_REGISTER_BEHANDLA, payload: data.results});
          dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
        } else {
          dispatch({type: ON_ERROR_ORDER_REGISTER_BEHANDLA, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_ORDER_REGISTER_BEHANDLA, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//getOrderRapport
export const getOrderRapport = (Afid,userid,Order)=>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_ORDER_RAPPORT});
  axios.get('kontos/Order/Rapport',
    { params:{
      Afid:Afid,
      userid:userid,
      Order:Order,
    }, 
    responseType: 'arraybuffer' ,
    headers: { 'Authorization': `Bearer ${jwt}`} }
    ).then((resp) => {
      const dirtyFileName = resp.headers['content-disposition'];
       const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
       var  fileName = dirtyFileName.match(regex)[3];
       var blob = new Blob([resp.data], 
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      dispatch({type: ON_FETCH_ORDER_RAPPORT, payload: resp});
      fileSaver.saveAs(blob, fileName);
      dispatch(RefreshUserInterface(userid))
    })
    .catch(function (error) {
      dispatch({type: ON_ERROR_FETCH_ORDER_RAPPORT, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      } 
    });
 }
}

//deleteThisOrderAnteckning
export const deleteThisOrderAnteckning = ( Orgnr, Afid, userid, OrderId,HandelseId) =>{
  const jwt = JSON.parse(localStorage.token);;
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_ORDER_HANDELSE});
     axios.delete('kontos/Order/Handelse/delete', {
       method: 'DELETE',
       data: {
        Orgnr:Orgnr,
         Afid:Afid,
         OrderId:OrderId,
         userid:userid,
         HandelseId:HandelseId
       },
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("deleteThisOrderAnteckning: ", data.message);
     if (data.results) {
       console.log(data);
       dispatch({type: ON_DELETE_ORDER_HANDELSE, payload: data.results});
       dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
     } else {
       dispatch({type: ON_ERROR_DELETE_ORDER_HANDELSE, payload: data.error});
     }
     ////dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
     dispatch({type: ON_ERROR_DELETE_ORDER_HANDELSE, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
   });
   }
}
//FlagThisOrderAnteckning
export const FlagThisOrderAnteckning =  ( Orgnr, Afid, userid, OrderId,Handelse) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_DELETE_ORDER_HANDELSE});
    axios.put('kontos/Order/Handelse/Flag', {
      
      body: {
       Afid:Afid,
       userid:userid,
       Orgnr:Orgnr,
       OrderId:OrderId,
       Handelse:Handelse
      },
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }    
    })
    .then(({data}) => {
      if (data.results) {
        console.log(data);
        dispatch({type: ON_DELETE_ORDER_HANDELSE, payload: data.results});
        dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
      } else {
        dispatch({type: ON_ERROR_DELETE_ORDER_HANDELSE, payload: data.error});
      }
    })
    .catch(function (error) {
      dispatch({type: ON_ERROR_DELETE_ORDER_HANDELSE, payload: error.message});
         if(!isUndefined(error.response)){
         if (error.response.status === 401) {
           dispatch({type: FETCH_START_SET_UNAUTHE});
          } 
        } 
        if(error.message === "Network Error"){
           //reload and remove token 
           //dispatch(userSignOut())
        } 
    });
  }
}
//EditThisOrderAnteckning
export const EditThisOrderAnteckning =  ( Orgnr, Afid, userid, OrderId,Handelse) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_DELETE_ORDER_HANDELSE});
    axios.put('kontos/Order/Handelse/update', {
      
      body: {
       Afid:Afid,
       userid:userid,
       Orgnr:Orgnr,
       OrderId:OrderId,
       Handelse:Handelse
      },
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }    
    })
    .then(({data}) => {
      if (data.results) {
        console.log(data);
        dispatch({type: ON_DELETE_ORDER_HANDELSE, payload: data.results});
        dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
      } else {
        dispatch({type: ON_ERROR_DELETE_ORDER_HANDELSE, payload: data.error});
      }
    })
    .catch(function (error) {
      dispatch({type: ON_ERROR_DELETE_ORDER_HANDELSE, payload: error.message});
         if(!isUndefined(error.response)){
         if (error.response.status === 401) {
           dispatch({type: FETCH_START_SET_UNAUTHE});
          } 
        } 
        if(error.message === "Network Error"){
           //reload and remove token 
           //dispatch(userSignOut())
        } 
    });
  }
}
//
//updateTillDashboard
export const updateTillDashboard =  (userid,Afid,Orgnr,OrderId,Handlaggare) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_ORDER_DASHBOARD_UPDATE});
      axios.put('kontos/Order/dashboard/Update', {
       
       body: {
        Afid:Afid,
        userid:userid,
        Orgnr:Orgnr,
        OrderId:OrderId,
        Handlaggare:Handlaggare,
       },
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("updateTillDashboard: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_NEW_ORDER_DASHBOARD_UPDATE, payload: data.results});
          dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
        } else {
          dispatch({type: ON_ERROR_ORDER_DASHBOARD_UPDATE, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_ORDER_DASHBOARD_UPDATE, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
 //ImportOrderKunddataExcelFile
 export const ImportOrderKunddataExcelFile = (Afid,userid,Orgnr,Aid,fileObj,AvtalId) =>{
  const jwt =  JSON.parse(localStorage.token);
  let files = fileObj.file; 
  console.log(files)
  var fromdata = new FormData();
  fromdata.append("Afid",Afid)
  fromdata.append("userid",userid)
  fromdata.append("Orgnr",Orgnr)
  fromdata.append("OrderId",Aid)
  fromdata.append("AvtalId",AvtalId)
  fromdata.append("AttFunction",fileObj.AttFunction)
  files.forEach(file => fromdata.append('files[]', file));
  return (dispatch) => {
    dispatch({type: ON_START_ORDER_IMPORT_KD_EXCEL});
    axios.post('kontos/Order/Kunddata/import',
    fromdata,
     {
       body:{
        Afid:Afid,
        userid:userid,
        Orgnr:Orgnr,
        OrderId:Aid,
        AvtalId:AvtalId,
        AttFunction:fileObj.AttFunction,
       },
       headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
     }
     ).then(({data}) => {
      console.log("ImportOrderKunddataExcelFile: ", data);
      if (data) {
        dispatch({type: ON_ORDER_IMPORT_KD_EXCEL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_ORDER_IMPORT_KD_EXCEL, payload: data.message});
       }
     //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
     dispatch({type: ON_ERROR_ORDER_IMPORT_KD_EXCEL, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
   });
  }
 }
//createNewKundIFortnoxFOrder
export const createNewKundIFortnoxFOrder = ( Orgrn, Afid, userid,AvtalID) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FORTNOX_NEWKUND_ORDER});
     axios.put('kontos/Order/Fortnox/NewKund', {
      
      body: {
        userid:userid,
        Afid:Afid,
        Orgrn:Orgrn,
        OrderId:AvtalID,
      },
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("createNewKundIFortnoxFOrder: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FORTNOX_NEWKUND_ORDER, payload: data.results});
         dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
       } else {
         dispatch({type: ON_ERROR_FORTNOX_NEWKUND_ORDER, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FORTNOX_NEWKUND_ORDER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
//getFortnoxKundFFbyKundnummerOrder
export const getFortnoxKundFFbyKundnummerOrder = ( Orgrn, Afid, userid,AvtalID,FortnoxKundNR) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FORTNOX_NEWKUND_ORDER});
     axios.put('kontos/Order/Fortnox/getKund', {
      
      body: {
        userid:userid,
        Afid:Afid,
        FortnoxKundNR:FortnoxKundNR,
        OrderId:AvtalID,
        Orgrn:Orgrn
      },
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("getFortnoxKundFFbyKundnummer: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FORTNOX_NEWKUND_ORDER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FORTNOX_NEWKUND_ORDER, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FORTNOX_NEWKUND_ORDER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
 }
 //CreateOrderFromSelectedKD
 export const CreateOrderFromSelectedKD = (Afid,userid,newOrder,selectedAKD,OldOrderid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_NEW_ORDER});
     axios.put('kontos/Order/newFKD', {
      
      body: {
        newOrder:newOrder,
        selectedAKD:selectedAKD,
        Afid:Afid,
        OldOrderid:OldOrderid,
        userid:userid
      },
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("CreateOrderFromSelectedKD: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_ORDER, payload: data.results});
         history.push({
          pathname: '/app/Orderkort',
          state: { OrderId: data.results.Order.Order[0] }
        });
        localStorage.setItem("Order",`${data.results.Order.Order[0].id}_${data.results.Order.Order[0].Orgnr}`);
       } else {
         dispatch({type: ON_ERROR_NEW_ORDER, payload: data.error});
       }
     ////dispatch(RefreshUserInterface(userid))
     let prospektFilter =isUndefined(localStorage.ProspektFilter)?[]:JSON.parse(localStorage.ProspektFilter)
     dispatch(getProspektByUserid1(Afid,userid,0,prospektFilter))
    }).catch(function (error) {
       dispatch({type: ON_ERROR_NEW_ORDER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     } 
     });
   }
 }
 //setORderVyType
export const setORderVyType = (Type) => {
  return (dispatch) => {
    dispatch({type:SET_ORDERVY_TYPE,payload:Type});
  }
}
//setOrderPage
export const setOrderPage = (Page) => {
  return (dispatch) => {
    dispatch({type: ON_GET_ORDER_PAGE_BASIC, payload: {Page:Page}});
   }
}
export const setOrderPageRows = (PageRows) => {
  return (dispatch) => {
    dispatch({type: ON_GET_ORDER_PAGEROWS_BASIC, payload: {PageRows:PageRows}});
   }
}
//onsendThisOrderToFortnox
export const onsendThisOrderToFortnox = ( Afid, userid,Order,WayOfDelivery,TermOfDelivery,Kommentar,Ertordernummer,
  Leveransdatum,LevNamn,Betalningsvillkor,KontaktTele,OurReference) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
     dispatch({type: ON_START_FORTNOX_SEND_ORDER});
     axios.put('kontos/Order/Fortnox/send', {
      
      body: {
        userid:userid,
        Afid:Afid,
        Order:Order,
        WayOfDelivery,TermOfDelivery,Kommentar,Ertordernummer,Leveransdatum,LevNamn,Betalningsvillkor,KontaktTele,
        OurReference
      },
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onsendThisOrderToFortnox: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FORTNOX_SEND_ORDER, payload: data.results});
         dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
       } else {
         dispatch({type: ON_ERROR_FORTNOX_SEND_ORDER, payload: data.error.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FORTNOX_SEND_ORDER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
//onsendUpdateOrderToFortnox
export const onsendUpdateOrderToFortnox = ( Afid, userid,Order,OrderLev,OrderFortnoxEd) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
     dispatch({type: ON_START_FORTNOX_SEND_ORDER});
     axios.put('kontos/Order/Fortnox/update', {
      
      body: {
        userid:userid,
        Afid:Afid,
        Order:Order,
        OrderLev:OrderLev,
        OrderFortnoxEd
      },
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onsendThisOrderToFortnox: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FORTNOX_SEND_ORDER, payload: data.results});
         dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
         
       } else {
         dispatch({type: ON_ERROR_FORTNOX_SEND_ORDER, payload: data.error.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FORTNOX_SEND_ORDER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }

//onCancelOrderUppgifterFortnox
export const onCancelOrderUppgifterFortnox = ( Afid,userid,OrderAfid,OrderId,OrderFortnox,callback ) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
     dispatch({type: ON_START_FORTNOX_CANCEL_ORDER});
     axios.put('kontos/Order/Fortnox/cancel', {
      
      body: {
        userid:userid,
        Afid:Afid,
        OrderAfid:OrderAfid,
        OrderId:OrderId,
        OrderFortnox:OrderFortnox
      },
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("onsendThisOrderToFortnox: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FORTNOX_CANCEL_ORDER, payload: data.results});
         dispatch(getOrderByIDRest1(data.results.Order.Order[0].Orgnr,Afid,userid, data.results.Order.Order[0].id))
         if(callback){callback()}
       } else {
         dispatch({type: ON_ERROR_FORTNOX_CANCEL_ORDER, payload: data.error.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FORTNOX_CANCEL_ORDER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     });
   }
 }
//getOrderUppgifterFortnox
export const getOrderUppgifterFortnox = (Afid,userid,OrderAfid,OrderId,OrderFortnox) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    dispatch({type: ON_START_GET_ORDER_FORTNOX});
    axios.get('kontos/Order/Fortnox',
    { params:{Afid:Afid,userid:userid,OrderAfid,OrderId,OrderFortnox}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getOrderUppgifterFortnox: ", data);
       if (data.results) {
        dispatch({type: ON_GET_ORDER_FORTNOX, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_ORDER_FORTNOX, payload: data.error});
      }
    }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ORDER_FORTNOX, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}

//onResetOrderMessage
export const onResetOrderMessage = () => {
  return (dispatch) => {
    dispatch({type: ON_START_NEW_ORDER_KALKYL_ID, payload: {Page:0}});
   }
}
 
//downloadExcelAvtalKunddata
export const downloadExcelOrderKunddata = (Afid,OrderType,OrderTypeId,AvtalId,OrderId)=>{
  const jwt =  JSON.parse(localStorage.token);
  
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_EXCEL_KUNDDATA_ORDER});
    axios.get('kontos/Order/Kunddata/download',
    { params:{
      Afid:Afid,
      OrderType:OrderType,
      OrderTypeId:OrderTypeId,
      OrderId:OrderId,AvtalId:AvtalId
    }, 
     responseType: 'arraybuffer' ,
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then((resp) => {
      // const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
       var  fileName = "Kunddata.xlsx";
       var blob = new Blob([resp.data], 
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      dispatch({type: ON_FETCH_EXCEL_KUNDDATA_ORDER, payload: resp});
      fileSaver.saveAs(blob, fileName);
     }).catch(function (error) {
       dispatch({type: ON_ERROR_EXCEL_KUNDDATA_ORDER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//downloadExcelOrderKunddata1
export const downloadExcelOrderKunddata1 = (Afid,OrderTypeId,OrderId)=>{
  const jwt =  JSON.parse(localStorage.token);
  
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_EXCEL_KUNDDATA_ORDER});
    axios.get('kontos/Order/Kunddata/download2',
    { params:{
      Afid:Afid,
      OrderTypeId:OrderTypeId,
      OrderId:OrderId
    }, 
     responseType: 'arraybuffer' ,
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then((resp) => {
      // const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
       var  fileName = "Kunddata.xlsx";
       var blob = new Blob([resp.data], 
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      dispatch({type: ON_FETCH_EXCEL_KUNDDATA_ORDER, payload: resp});
      fileSaver.saveAs(blob, fileName);
     }).catch(function (error) {
       dispatch({type: ON_ERROR_EXCEL_KUNDDATA_ORDER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//onUpdateFortnoxOrder
export const onUpdateFortnoxOrder = (OrderFortnoxEd)=>{
  return (dispatch) => {
    dispatch({type: ON_UPDATE_ORDER_FORNOX,payload:OrderFortnoxEd});
  }
}
//setNewsearchtype
export const setNewsearchtype = (searchtype)=>{
  return (dispatch) => {
    dispatch({type: ON_UPDATE_ORDER_LIST_SEARCHTYPE,payload:searchtype});
  }
}
//setNewsearchOrderWord
export const setNewsearchOrderWord = (searchtype)=>{
  return (dispatch) => {
    dispatch({type: ON_UPDATE_ORDER_LIST_SEARCHWORD,payload:searchtype});
  }
}
//onCloseOrderToaster
export const onCloseOrderToaster = () => {
  return (dispatch) => {
    dispatch({type:ON_START_ORDER_CLOSE_TOASTR});
  }
}
//getSearchableArtikelFreeInputs
export const getSearchableArtikelFreeInputs = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    dispatch({type: ON_START_GET_SEARCHABLE_ARTKEL_FI});
    axios.get('kontos/Artikla/freeinput/searchable/get',
    { params:{Afid:Afid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getSearchableArtikelFreeInputs: ", data);
       if (data.results) {
        dispatch({type: ON_GET_SEARCHABLE_ARTKEL_FI, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_SEARCHABLE_ARTKEL_FI, payload: data.error});
      }
    }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_SEARCHABLE_ARTKEL_FI, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
export const getOrderStatusAntal = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    dispatch({type: ON_START_GET_ORDER_STATUS_ANTAL});
    axios.get('kontos/Order/getOrderStatusAntal',
    { params:{Afid,userid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getOrderStatusAntal: ", data);
       if (data.results) {
        dispatch({type: ON_GET_ORDER_STATUS_ANTAL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_ORDER_STATUS_ANTAL, payload: data.error});
      }
    dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ORDER_STATUS_ANTAL, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
// ON_UPDATE_THIS_ORDER_STATUS,
//     ON_ERROR_UPDATE_THIS_ORDER_STATUS,
//     ON_START_UPDATE_THIS_ORDER_STATUS,
export const updateThisOrderStatus = (Afid,userid,Status,Orderid) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
   dispatch({type: ON_START_UPDATE_THIS_ORDER_STATUS});
   axios.put('kontos/Order/updateThisOrderStatus',
   { body:{Afid,userid,Status,Orderid}, 
    }, {headers: { 'Authorization': `Bearer ${jwt}`} }      
    ).then(({data}) => {
     console.log("updateThisOrderStatus: ", data);
      if (data.results) {
       dispatch({type: ON_UPDATE_THIS_ORDER_STATUS, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_UPDATE_THIS_ORDER_STATUS, payload: data.error});
     }
   dispatch(RefreshUserInterface(userid))
   }).catch(function (error) {
      dispatch({type: ON_ERROR_UPDATE_THIS_ORDER_STATUS, payload: error.message});
         if(!isUndefined(error.response)){
       if (error.response.status === 401) {
         dispatch({type: FETCH_START_SET_UNAUTHE});
        } 
      } 
      if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      } 
    }); /**/
 }
}

//getOrderFressInputsByAf
export const getOrderFressInputsByAf = (Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    dispatch({type: ON_START_GET_ORDER_FREE_INPUTS});
    axios.get('kontos/Order/getOrderFressInputs',
    { params:{Afid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getOrderStatusAntal: ", data);
       if (data.results) {
        dispatch({type: ON_GET_ORDER_FREE_INPUTS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_ORDER_FREE_INPUTS, payload: data.error});
      }
    }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ORDER_FREE_INPUTS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
//getPrevNextOrderbyAfid
export const getPrevNextOrderbyAfid = (Afid,userid,Orderid,Filterstate,type,searchWord,searchtype) =>{
  searchtype = (isUndefined(searchtype)?0:searchtype)
  searchWord = (isUndefined(searchWord)?"":searchWord)
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {    
    dispatch({type: ON_START_GET_ORDER_USER_NEXT_PREV});
    axios.get('kontos/Order/getByUser/Nextprev',
    { params:{
      Afid:Afid,userid:userid,type:type,searchWord:searchWord,
      Filterstate:Filterstate,searchtype:searchtype,Orderid
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getOrderByUserID: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_ORDER_USER_NEXT_PREV, payload: data.results});
         
       } else {
         dispatch({type: ON_ERROR_GET_ORDER_USER_NEXT_PREV, payload: data.error});
       }
     dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ORDER_USER_NEXT_PREV, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//CreateSnabbVunnen
export const CreateSnabbVunnen=(Afid,userid,Orgnr,Avtalid,stateObj)=>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_SNABB_VUNNEN});
    axios.put('kontos/prospekt/Snabb', {
     
     body: {
        Avtalid:Avtalid,
        Orgnr:Orgnr,
        Afid:Afid,
        stateObj:stateObj,
        userid:userid
     }
    },{
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(({data}) => {
     console.log("CreateSnabbVunnen: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_SNABB_VUNNEN, payload: data.results});
        history.push({
          pathname: '/app/AvtalsKort',
          state: { AvtalId: data.results.Avtal.Avtal[0] }
        });
      } else {
        dispatch({type: ON_ERROR_SNABB_VUNNEN, payload: data.error});
      }
 //   ////dispatch(RefreshUserInterface(userid))
  }).catch(function (error) {
      dispatch({type: ON_ERROR_SNABB_VUNNEN, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
    });
  }
}  
//createNewAfOrderTask
export const createNewAfOrderTask = (Userid, Afid, Task) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_NEW_AF_ORDER_TASK});
      axios.post('kontos/Order/Task/createNewAfOrderTask', {
       method: 'POST',
       body: {
          Afid, Userid, Task
       }
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
      },{ 
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
    } ).then(({data}) => {
       console.log("createNewAfOrderTask: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_NEW_AF_ORDER_TASK, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_NEW_AF_ORDER_TASK, payload: data.error});
        }
        //dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_NEW_AF_ORDER_TASK, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
 export const getAfOrderTask = (Userid,Afid) =>{

  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AF_ORDER_TASK});
    await axios.get('kontos/Order/Task/getAfOrderTask',
    { params:{
      Afid:Afid,
      Userid:Userid,
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAfOrderTask: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AF_ORDER_TASK, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AF_ORDER_TASK, payload: data.error});
       }
       dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AF_ORDER_TASK, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//
export const updateAfOrderTask = (Userid, Afid, Task) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_UPDATE_AF_ORDER_TASK});
      axios.put('kontos/Order/Task/updateAfOrderTask', {
       
       body: {
          Afid, Userid, Task
       }
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
      },{
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
    } ).then(({data}) => {
       console.log("updateAfOrderTask: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_UPDATE_AF_ORDER_TASK, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_UPDATE_AF_ORDER_TASK, payload: data.error});
        }
        //dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_AF_ORDER_TASK, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
export const updateAfOrderTaskOrder = (Userid, Afid, Tasks) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_UPDATE_AF_ORDER_TASK});
      axios.put('kontos/Order/Task/updateAfOrderTaskOrder', {
       
       body: {
          Afid, Userid, Tasks
       }
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
      },{
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
    } ).then(({data}) => {
       console.log("updateAfOrderTaskOrder: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_UPDATE_AF_ORDER_TASK, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_UPDATE_AF_ORDER_TASK, payload: data.error});
        }
        //dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_AF_ORDER_TASK, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
 //deleteAfOrderTask
 export const deleteAfOrderTask = (Userid, Afid, TaskId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_DELETE_AF_ORDER_TASK});
    await axios.delete('kontos/Order/Task/deleteAfOrderTask',
    { params:{
      Afid, Userid, TaskId
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("deleteAfOrderTask: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_AF_ORDER_TASK, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_AF_ORDER_TASK, payload: data.error});
       }
       dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_AF_ORDER_TASK, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const changecanUpdKDProject = (Afid,userid,Orgnr,OrderId,canUp) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_UPDATE_ORDER_KUNDDATA_KANUPDATE});
      axios.put('kontos/Order/kunddate/update/can', {
       
       body: {
        Afid, userid, Orgnr,canUp,OrderId
       }
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
      },{
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
    } ).then(({data}) => {
       console.log("updateAfOrderTaskOrder: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_UPDATE_ORDER_KUNDDATA_KANUPDATE, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_UPDATE_ORDER_KUNDDATA_KANUPDATE, payload: data.error});
        }
        //dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_ORDER_KUNDDATA_KANUPDATE, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
 export const setOrderSort = (nSortObj) => {
  return (dispatch) => {
    localStorage.setItem("OrderSortObj", JSON.stringify(nSortObj));
    dispatch({type: ON_GET_CHANGE_ORDER_VY_SORT, payload: {OrderSortObj:nSortObj}});
   }
}
